import { connect } from 'react-redux';
import { updateError, updateFieldValue, displayToast, resetValues, verifyEmailAddress, addUser, getUserDetails, getLanguageDetails, fetchRegexRequest } from 'src/Actions/Admin/adminActions';
import { manageSidemenu } from "src/Actions/Generic/genericActions";
import AddAdmin from './AddAdmin';

const mapStateToProps = ({ admin }) => ({
  admin
});

const mapDispatchToProps = (dispatch) => ({
  updateFieldValue: (fieldValue) => dispatch(updateFieldValue(fieldValue)),
  updateError: (errorValue) => dispatch(updateError(errorValue)),
  displayToast: (val) => dispatch(displayToast(val)),
  resetValues: () => dispatch(resetValues()),
  verifyEmailAddress: (activationKey, persona, email) => dispatch(verifyEmailAddress(activationKey, persona, email)),
  addUser: (userRequest, isEdit) => dispatch(addUser(userRequest, isEdit)),
  getUserDetails: (emailId, activationKey) => dispatch(getUserDetails(emailId, activationKey)),
  getLanguageDetails: () => dispatch(getLanguageDetails()),
  manageSidemenu: (val) => dispatch(manageSidemenu(val)),
  fetchRegexRequest: () => dispatch(fetchRegexRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAdmin);